import {clamp} from './numberHelper';

export function getMapBaseSize(imageWidth: number, imageHeight: number): number {
    const largestDimension = Math.max(imageHeight, imageWidth);
    const factor = largestDimension / 1000;
    if (factor <= 1.5) {
        return 1;
    }
    return clamp(factor, 1, 3);
}

export function calculatePolygonCenter(vertices: [number, number][]): [number, number] {
    if (vertices.length === 0) {
        throw new Error('The vertices array must not be empty.');
    }

    let sumX = 0;
    let sumY = 0;

    for (const [x, y] of vertices) {
        sumX += x;
        sumY += y;
    }

    const centerX = sumX / vertices.length;
    const centerY = sumY / vertices.length;

    return [centerX, centerY];
}
